import { EventEmitter } from "events";

export const EVENTS = {
	TAB_SWITCHED: "tab-switched",
	WINDOW_RESIZE: "window-resize",
	CAMERA_RESET: "camera-reset",
	REPORT_IMAGES_SENT: "report-images-sent"
};

export const EventManager = new EventEmitter();



// WEBPACK FOOTER //
// ./src/components/Events/events.js